"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsMedia = require("@schlagerkhan/styled-components-media");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tflex: 1;\n\n\tmargin-left: auto;\n\tmargin-right: auto;\n\n\t", ";\n\n\t", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\t\t", ";\n\n\t\t", ";\n\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\t\t", ";\n\n\t\t", ";\n\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\t\t\t", " {\n\t\t\t\t", "\n\t\t\t}\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\t\tpadding-left: ", "px;\n\t\tpadding-right: ", "px;\n\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t\tmax-width: ", "px;\n\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function createMaxWidth(maxWidth) {
  return (0, _styledComponents.css)(_templateObject(), maxWidth);
}

function createPadding(padding) {
  return (0, _styledComponents.css)(_templateObject2(), padding, padding);
}
/**
 * Loops through the css-media-values and inserts them
 * in the corresponding minMedia query.
 */


function createMediaCssArray(values, fn) {
  var keys = Object.keys(values);
  return keys.map(function (key) {
    var value = values[key];
    return (0, _styledComponents.css)(_templateObject3(), _styledComponentsMedia.minMedia[key], fn(value));
  });
}
/**
 * Creates the max-widths for all the media queries
 */


function maxWidthStyle(_ref) {
  var theme = _ref.theme;

  var _theme$contentMediaMa = theme.contentMediaMaxWidths,
      initial = _theme$contentMediaMa.initial,
      maxWidths = _objectWithoutProperties(_theme$contentMediaMa, ["initial"]);

  var initialMaxWidth = initial && createMaxWidth(initial);
  var maxWidthCssArray = createMediaCssArray(maxWidths, createMaxWidth);
  return (0, _styledComponents.css)(_templateObject4(), initialMaxWidth, maxWidthCssArray);
}
/**
 * Create the paddings for all the media queries
 */


function paddingStyle(_ref2) {
  var theme = _ref2.theme;

  var _theme$contentMediaPa = theme.contentMediaPaddings,
      initial = _theme$contentMediaPa.initial,
      paddings = _objectWithoutProperties(_theme$contentMediaPa, ["initial"]);

  var initialPadding = initial && createPadding(initial);
  var paddingCssArray = createMediaCssArray(paddings, createPadding);
  return (0, _styledComponents.css)(_templateObject5(), initialPadding, paddingCssArray);
}

var Content = _styledComponents["default"].div(_templateObject6(), maxWidthStyle, paddingStyle);

exports.Content = Content;
_styledComponents["default"].Content = (0, _styledComponents["default"])(Content);